import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
// import Testimonials from "./components/Testimonials";
import BackToTop from "./components/BackToTop";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font ">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      {/* <Testimonials /> */}
      <Contact />
      <BackToTop />
    </main>
  );
}


// WEBPACK FOOTER //
// ./src/App.js